import React from 'react';

const Section = ({gray, className, children}) => {
return <div className={`${gray ? 'bg-tb-gray' : ''} ${className ? className : ''}  `}>
  {children}
  </div>
}

export default Section;